var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile is-child box trigger",style:({ 'background-color': ("rgb(" + (_vm.value.r) + "," + (_vm.value.g) + "," + (_vm.value.b) + ")") }),attrs:{"id":_vm.componentId}},[_c('div',{staticClass:"level"},[_c('div',{staticClass:"level-item has-text centered"},[_c('p',{staticClass:"subtitle is-4",style:({ 'color': _vm.fontColor })},[_vm._v("\n                "+_vm._s(_vm.text)+"\n            ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a1c7e8f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TileColorPicker.vue
// module id = 620
// module chunks = 0